import {number, string, func, arrayOf, oneOf, object} from 'prop-types';
import setDisplayName from 'recompose/setDisplayName';
import withProps from 'recompose/withProps';
import compose from 'recompose/compose';
import {ItemExplorerViewOptions, pageCount, EmptyFunc} from 'utils/DBUtils';
import ItemExplorer from 'components/common/ItemExplorer';
import {TableViewModes} from '../utils';
import Columns from './columns';

const ColumnsByMode = {
  [TableViewModes.ReadOnly]: [
    Columns.Title,
    Columns.Points,
    Columns.Price,
    Columns.Cost,
    Columns.Allocated,
    Columns.InStock,
    Columns.Purchased
  ],

  [TableViewModes.Live]: [
    Columns.Title,
    Columns.Points,
    Columns.Price,
    Columns.Cost,
    Columns.Allocated,
    Columns.InStock,
    Columns.Purchased,
    Columns.AddRemoveButtons
  ],

  [TableViewModes.Planning]: [
    Columns.Title,
    Columns.QuantityInput,
    Columns.Points,
    Columns.Price,
    Columns.Cost
  ]
};

const RewardsTable = compose(
  withProps(props => ({
    showView: ItemExplorerViewOptions.List,
    itemsOnly: true,
    filterBarProps: {
      hidden: true
    },
    pagingBarProps: {
      count: pageCount(props.totalRewards, props.pageSize),
      total: props.totalRewards,
      currentPage: props.currentPage,
      maxPages: 10,
      onPageSelected: props.onPageSelected,
      onNextClicked: props.onNextClicked,
      onPreviousClicked: props.onPreviousClicked
    },
    tableProps: {
      items: props.rewards,
      onRowClicked: EmptyFunc,
      getSortDirectionForField: props.getSortDirectionForField,
      onSortClick: colDetails => {
        if (colDetails.fieldName) {
          props.selectSort(colDetails.fieldName);
        }
      },

      // some columns depend on props, so pass them into all columns.
      colDetails: ColumnsByMode[props.tableMode].map(col => col(props))
    }
  })),
  setDisplayName('RewardsTable')
)(ItemExplorer);

RewardsTable.propTypes = {
  tableMode: oneOf(Object.keys(TableViewModes)).isRequired,
  lang: string.isRequired,
  escrows: arrayOf(object),
  rewards: arrayOf(object),
  updateQuantity: func.isRequired,

  openRetailerItemModal: func.isRequired,
  openPurchaseInfoModal: func.isRequired,
  openIncreaseItemStockModal: func.isRequired,
  openDecreaseItemStockModal: func.isRequired,

  totalRewards: number.isRequired,
  pageSize: number.isRequired,
  currentPage: number.isRequired,
  onPageSelected: func.isRequired,
  onNextClicked: func.isRequired,
  onPreviousClicked: func.isRequired,

  getSortDirectionForField: func.isRequired,
  selectSort: func.isRequired,
};

export default RewardsTable;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/RewardsTable.jsx